import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDateFormats } from '@angular-material-components/datetime-picker';
import { NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS, NgxMatMomentAdapter } from '@angular-material-components/moment-adapter';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output, SkipSelf } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';

export const MY_FORMATS: NgxMatDateFormats = {
  parse: {
    dateInput: 'l, LTS',
  },
  display: {
    dateInput: 'DD/MM/YYYY HH:mm',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-generic-datetimepicker',
  templateUrl: './generic-datetimepicker.component.html',
  styleUrl: './generic-datetimepicker.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    {
      provide: NgxMatDateAdapter,
      useClass: NgxMatMomentAdapter,
      deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: NGX_MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class GenericDateTimePickerComponent {

  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() label!: string;
  @Input() placeholder: string = '';
  @Input() width: string = '100%';
  @Input() isStartDate: boolean = false;
  @Input() isEndDate: boolean = false;
  @Input() readonly: boolean = false;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() value?: Date;
  @Output() dateChanged = new EventEmitter<string>();

  handleDateChange(event: any) {
    const value = event.value;
    if (moment.isMoment(value) && value.isValid()) {
      const formatted = value.format('YYYY-MM-DDTHH:mm');
      this.formGroup.get(this.controlName)?.setValue(formatted, { emitEvent: false });
      this.dateChanged.emit(event);
    }
  }
}
